
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useAccountAdd } from '@/modules/account/system/model/add';
import { ROUTE_NAME_ACCOUNT } from '@/modules/account/router';

export default defineComponent({
    name: ROUTE_NAME_ACCOUNT.SYSTEM.ADD,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, actions } = useAccountAdd();

        return { v$, model, actions };
    }
});
